import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { UserService } from '@nrwl/rx-service-user';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxButtonModule } from '@nrwl/rx-button';
import { CommonModule } from '@angular/common';
import { RxRowModule } from '@nrwl/rx-row';
import { RxInputModule } from '@nrwl/rx-input';

@Component({
  selector: 'ask-password',
  templateUrl: './rx-ask-password.component.html',
  styleUrls: ['./rx-ask-password.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxIconModule,
    RxButtonModule,
    RxRowModule,
    RxInputModule,
  ],
})
export class RxAskPasswordComponent implements OnInit {
  passForm: FormGroup | any;
  errorMessage = '';
  public passChecking = false;

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.submitData();
    }
  }

  constructor(
    private dialogRef: MatDialogRef<RxAskPasswordComponent>,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.passForm = this._fb.group({
      password: new FormControl('', [Validators.required]),
    });
    this.passForm.get('password').valueChanges.subscribe((res) => {
      this.errorMessage = '';
    });
  }

  submitData() {
    if (this.passForm.valid) {
      this.passChecking = true;
      const payload = { password: this.passForm.get('password').value };
      this.userService.checkUserPassword(this.data.payload.doctorId, payload).subscribe(
        (res) => {
          this.passChecking = false;
          this.dialogRef.close({ success: true });
        },
        (error) => {
          this.errorMessage = 'Incorrect password.';
          this.passChecking = false;
        },
      );
    } else {
      this.errorMessage = 'Incorrect password.';
    }
  }

  cancelDialog() {
    this.dialogRef.close({ success: false });
  }
}
